export const environment = {
	production: true,
	apiUrl: '/api',
	sentryDSN: null,
	socketUrl: null,
	CLOUD_URL: null,
};
